import { Record, Map } from "immutable";

const ProjectFiltersRecord = Record(
  {
    projectId: null,
    filters: Map({
      taskListId: null,
      assigneeId: null,
      dateId: null,
      labelId: null,
      status: `all`,
    }),
  },
  `ProjectFilters`
);

class ProjectFilters extends ProjectFiltersRecord {}

export default ProjectFilters;
